export default __webpack_public_path__ + "static/media/newChildrensImage.406d694c.jpeg";